import SessionEventProto from "../session-event-proto"

type Header = {
    taskId          : ID
    taskMessageId   : ID
    timeReportId    : ID
    isBulkUpdate    : boolean
}

export default class SessionTimeReportEvent extends SessionEventProto {

    private header  : Header

    constructor(sessionEvent:any) {
        super(sessionEvent)
        this.header     = {
            taskId          : sessionEvent.task.id,
            taskMessageId   : sessionEvent.taskMessage.id,
            timeReportId    : sessionEvent.timeReport.id,
            isBulkUpdate    : sessionEvent.isBulkUpdate,
        }
    }

    process() {
        if (this.isDifferentCompany()) return false

        const id = '{0}-{1}'.f(this.header.taskId, this.header.taskMessageId)
        gd.modelBus.newUpdate('time-report', this.method, id, this.data, this.header)
    }
}
